// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, number, string } from 'prop-types'
import Modal from 'react-modal'
import useContactDetails from './useContactDetails'
import ContactInfo from './ContactInfo'
import CompanyInfo from './CompanyInfo'
import CompaniesHeader from './CompaniesHeader'

import {
  CompaniesWrapper,
  ModalContainer,
} from './styles'

const ModalWrapper = props => {
  const {
    closeModal,
    idRoot,
  } = props

  const contactData = useContactDetails(props)

  return (
    contactData &&
    <Modal
      className={'modal-content-default padding-0'}
      contentLabel={'Contact Details Modal'}
      isOpen={true}
      onRequestClose={closeModal}
      overlayClassName={'modal-overlay-default'}>
      <h2 className={'bg-blue-dark padding-half display-flex justify-content-between'}>
        <span>{'Contact Details'}</span>
        <span
          id={`${idRoot}-header-close`}
          onClick={closeModal}>
          {'X'}
        </span>
      </h2>
      <ModalContainer>
        <div className={'padding-1 display-flex flex-direction-column'}>
          <ContactInfo
            contact={contactData}
            idRoot={`${idRoot}-contact`} />
          <CompaniesHeader companyCount={contactData.companies.length} />
          <CompaniesWrapper>
            {
              contactData.companies.map(d => (
                <CompanyInfo
                  key={d.companyId}
                  company={d}
                  idRoot={`${idRoot}-${d.companyId}`}/>
              ))
            }
          </CompaniesWrapper>
        </div>
      </ModalContainer>
    </Modal>
  )
}

ModalWrapper.propTypes = {
  closeModal: func.isRequired,
  contactId: number.isRequired,
  idRoot: string.isRequired,
}

export default ModalWrapper
